<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { AddIcon, CheckIcon } from "../icons";
import { api, errorText } from "../api";
import RecordForm from "../components/RecordForm.vue";
const id = String(useRoute().params.id),
  form = ref<any>(null),
  error = ref(""),
  open = ref(false),
  saved = ref(false);
onMounted(async () => {
  try {
    form.value = await api("/api/forms/" + id);
  } catch (e) {
    error.value = errorText(e);
  }
});
</script>
<template>
  <div class="page-heading">
    <div>
      <h1>{{ form?.name ?? "Formular" }}</h1>
      <p class="subtitle">Send en ny række til datasættet.</p>
    </div>
  </div>
  <p v-if="error" class="error" role="alert">{{ error }}</p>
  <section v-if="form" class="working-panel form-intro">
    <h2>
      {{
        form.fields.filter((f: any) => !f.inputHidden && !f.calculation).length
      }}
      felter, klar til indtastning
    </h2>
    <p class="muted">
      {{
        form.fields
          .filter((f: any) => !f.inputHidden && !f.calculation)
          .map((f: any) => f.label)
          .join(" · ")
      }}
    </p>
    <p v-if="saved" class="notice success-notice" role="status">
      <CheckIcon :size="18" />Din række er gemt.
    </p>
    <button class="button primary" @click="open = true">
      <AddIcon :size="18" />Udfyld formular
    </button>
  </section>
  <RecordForm
    v-if="open && form"
    :dataset="form.datasetId"
    :fields="form.fields"
    :form-id="id"
    @close="open = false"
    @saved="saved = true"
  />
</template>
